import React, { useState, useEffect } from 'react';
import Imagez from '../../../../../lib/reusable/Imagez';
import LayersIcon from '@mui/icons-material/Layers';
import { COLORS } from '../../../../../utils/colors';


const TreeCategoryElement = (props) => {
  const { category } = props;
  const [errorImage, setErrorImage] = useState(false);

  const handleNoImage = () => {
    setErrorImage(true);
  };

  useEffect(() => {
    setErrorImage(false);
  }, [category])

  const hasImage = category.has_image && category.image && !errorImage;
  const hasRandomImage = category.randomImageFromProducts !== undefined;

  const square = '40px';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        opacity: category.active ? 1 : 0.3,
        marginLeft: '-4px',
        borderLeft: `2px solid ${COLORS.INFO}`,
        // borderRadius: '4px',
        padding: '8px',
        backgroundColor: `${COLORS.INFO}05`,
        boxShadow: '0px 6px 8px -3px #00000040',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.9rem' }}>
        <div
          style={{
            fontWeight: 'bold',
            letterSpacing: '-0.024em',
            marginRight: '10px',
            fontSize: '0.64rem',
            minWidth: '16px',
          }}
        >
          {Math.abs(category.position)}
        </div>
        {(hasImage || hasRandomImage) ? (
          <div style={{ width: square, borderRadius: '4px' }}>
            <Imagez
              br="4px"
              image={category.has_image ? category.image : hasRandomImage ? category.randomImageFromProducts : null}
              height={square}
              handleNoImage={handleNoImage}
              style={{ opacity: category.active ? 1 : 0.3 }}
              loaderWidth={30}
            />
          </div>
        ) : (
          <div style={{ width: square, height: square, background: '#ccc', borderRadius: '4px' }} />
        )}
        {category.group && (
          <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
            <LayersIcon className="txt-info s-24-i" />
          </div>
        )}
        <div style={{ fontWeight: 'bold', letterSpacing: '-0.024em', marginLeft: '10px' }}>
          {category.name}
        </div>
      </div>
    </div>
  );
};

export default TreeCategoryElement;
